<template>
  <ValidateWarning
    title="Validate CSV Data"
    show
    :ignore="ignore"
    :btn-show-more="displayShowMoreBtn"
    @ignore="$emit('ignore')"
  >
    <template v-slot:warning-list="slotProps">
      <b-col
        v-if="invalidWarning"
        cols="12"
      >
        <h6>Error</h6>
        <ul>
          <li>
            {{ invalidWarning }}
          </li>
        </ul>
      </b-col>
      <ValidateWarningList
        v-if="missingHeadings.length > 0 || newHeadings.length > 0"
        header="Missing CSV Headings"
        message="The following headings are present in the original CSV but not in the new CSV. This means some configuration may not be applied correctly in the new version."
        :list="missingHeadings"
        :show-more="slotProps.showMore"
      />
      <ValidateWarningList
        v-if="missingHeadings.length > 0 || newHeadings.length > 0"
        header="New CSV Headings"
        message="The following headings are present in the new CSV but not in the original CSV. If there are typos or different capitalisation this can be resolved by fixing the new CSV and re-uploading."
        :list="newHeadings"
        :show-more="slotProps.showMore"
      />
      <ValidateWarningList
        v-if="missingBranches.length > 0 || newBranches.length > 0"
        header="Missing Projects"
        message="The following projects are present in the original CSV but not in the new CSV. Any stories and settings associated with these projects will be discarded."
        :list="missingBranches"
        :show-more="slotProps.showMore"
      />
      <ValidateWarningList
        v-if="missingBranches.length > 0 || newBranches.length > 0"
        header="New Projects"
        message="The following projects are present in the new CSV but not in the original CSV. If there are typos or different capitalisation this can be resolved by fixing the new CSV and re-uploading."
        :list="newBranches"
        :show-more="slotProps.showMore"
      />
    </template>
  </ValidateWarning>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import { MINIMAL_LENGTH_LIST } from '@/constants'
import ValidateWarning from '@/components/admin/upload/ValidateWarning.vue'
import ValidateWarningList from '@/components/admin/upload/ValidateWarningList.vue'

const components = {
  ValidateWarning, ValidateWarningList,
}

const props = {
  result: {
    type: Object,
    default: () => ({}),
  },
  ignore: {
    type: Boolean,
    require: true,
  },
}

@Component({ components })
export default class UpdateValidateWarning extends Vue.extend({ props }) {
  get missingBranches () {
    return this.getFromResult('missing branches')
  }

  get newBranches () {
    return this.getFromResult('new branches')
  }

  get missingHeadings () {
    return this.getFromResult('missing headings')
  }

  get newHeadings () {
    return this.getFromResult('new headings')
  }

  get invalidWarning () {
    if (this.result.invalid) return this.result.type
    else return ''
  }

  get displayShowMoreBtn () {
    return this.missingHeadings.length > MINIMAL_LENGTH_LIST || this.newHeadings.length > MINIMAL_LENGTH_LIST || this.missingBranches.length > MINIMAL_LENGTH_LIST || this.newBranches.length > MINIMAL_LENGTH_LIST
  }

  getFromResult (name: string):string[] {
    if (this.result[name]) {
      return Array.from(this.result[name].sort())
    } else {
      return []
    }
  }
}

</script>
